import React from "react";
import styles from "./Style.module.css";

const formatMoney = (value) => {
  const amount = Number(value);
  return (Number.isFinite(amount) ? amount : 0).toFixed(2);
};

/** Category GST + Subtotal block (review layout). Subtotal = items + GST. */
const VoucherSubtotal = ({ itemsTotal = 0, gstAmount = 0 }) => {
  const subtotal = Number(itemsTotal) + Number(gstAmount);

  return (
    <div className={styles.reviewPriceDetails}>
      {/* <div className={styles.reviewPriceDetailsItem}> */}
        {/* <div className={styles.reviewPriceDetailsItemLeft}>GST (9%)</div>
        <div className={styles.reviewPriceDetailsItemRight}>
          ${formatMoney(gstAmount)}
        </div> */}
      {/* </div> */}
      <div className={`${styles.reviewPriceDetailsItem} ${styles.subtotalRow}`}>
        <div className={styles.reviewPriceDetailsItemLeft}>Subtotal</div>
        <div className={styles.reviewPriceDetailsItemRight}>
          S${formatMoney(subtotal)}
        </div>
      </div>
    </div>
  );
};

export default VoucherSubtotal;
